export const VOLATILIDADE_CHART_OPTIONS = {
	chart: {
		height: 350,

		type: 'line',
		stacked: false,
		toolbar: {
			show: false,
		},
		zoom: {
			enabled: false,
		},
	},
	stroke: {
		width: [0, 2, 2],
		curve: 'straight',
	},
	plotOptions: {
		bar: {
			columnWidth: '50%',
		},
	},

	legend: {
		markers: {
			width: 20,
			height: 4,
			radius: 0,
		},
		horizontalAlign: 'left',

		itemMargin: {
			vertical: 20,
		},
	},

	fill: {
		opacity: [1, 1, 1],
		gradient: {
			inverseColors: false,
			shade: 'light',
			type: 'vertical',
			opacityFrom: 0.85,
			opacityTo: 0.55,
			stops: [0, 100, 100, 100],
		},
	},

	markers: {
		size: 0,
	},
	colors: ['#6B0000', '#840505', '#9E1616'],

	yaxis: {
		title: {
			text: '',
		},
	},
}

export const VOLATILIDADE_CHART_ID_1M = '#chart-volatilidade-1m'
export const VOLATILIDADE_CHART_ID_3M = '#chart-volatilidade-3m'
